import React from "react";
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
  AlignmentType,
  BorderStyle,
  VerticalAlign,
  ShadingType,
  TableRowHeight,
} from "docx";

const labelTranslations = {
  name: "Emri i operatorit",
  legalForm: "Personi fizik ose juridik",
  shareHolders: "Pronësia",
  TV: "TELEVIZIONE",
  RADIO: "Radiot",
  CABLE: "Kabllorët",
  OTHER: "Tjetër",
};

const columnOrder = ["name", "legalForm", "shareHolders"];
const columnWidths = {
  name: 26,
  legalForm: 37,
  shareHolders: 37,
};

const ModelWorldShareholding = (tableContent) => {
  const groupedByType = tableContent.reduce((acc, item) => {
    const type = item.type === "Tjetër" ? "OTHER" : item.type || "OTHER";
    if (!acc[type]) acc[type] = [];
    acc[type].push(item);
    return acc;
  }, {});

  const createTableCell = (
    text,
    bold = false,
    header = false,
    widthPercent = 33
  ) =>
    new TableCell({
      verticalAlign: VerticalAlign.CENTER,
      width: {
        size: widthPercent * 50,
        type: WidthType.PERCENTAGE,
      },
      margins: {
        top: 30, // në twips (1/20 i pikës, 100 = 5pt)
        bottom: 30,
        left: 40, // 200 = 10pt
        right: 40,
      },
      shading: header
        ? {
            type: ShadingType.CLEAR,
            fill: "ED1D25",
          }
        : {
            type: ShadingType.CLEAR,
          },
      children: [
        new Paragraph({
          children: [
            new TextRun({
              text: text,
              bold: bold,
              color: header ? "FFFFFF" : "000000",
              size: 24,
            }),
          ],
          alignment:
            widthPercent === 20 ? AlignmentType.LEFT : AlignmentType.CENTER,
        }),
      ],
      borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
        right: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
      },
    });

  const buildTable = (items) => {
    const rows = [];

    // Header row
    rows.push(
      new TableRow({
        children: columnOrder.map((key) =>
          createTableCell(
            labelTranslations[key] || key,
            true,
            true,
            columnWidths[key]
          )
        ),
        height: { value: 900, rule: TableRowHeight.EXACT },
        tableHeader: true,
      })
    );

    // Data rows
    for (const item of items) {
      const cells = columnOrder.map((key) => {
        const value = item[key];

        if (key === "shareHolders" && Array.isArray(value)) {
          const children = value.map(
            (sh) =>
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({ text: sh.name }),
                  new TextRun({ text: ` (${sh.percentage}%)`, bold: false }),
                ],
              })
          );
          return new TableCell({
            children,
            verticalAlign: VerticalAlign.CENTER,
            margins: {
              top: 30, // në twips (1/20 i pikës, 100 = 5pt)
              bottom: 30,
              left: 40, // 200 = 10pt
              right: 40,
            },
            width: {
              size: columnWidths[key] * 50,
              type: WidthType.PERCENTAGE,
            },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              left: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
              right: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
            },
          });
        }

        return createTableCell(value || "", false, false, columnWidths[key]);
      });

      rows.push(new TableRow({ children: cells }));
    }

    return new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows,
      borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
        right: { style: BorderStyle.NONE, size: 1, color: "FFFFFF" },
      },
    });
  };

  const typeOrder = ["TV", "RADIO", "CABLE", "OTHER"];
  const docSections = [];

  typeOrder.forEach((type) => {
    const items = groupedByType[type];
    if (!items) return;

    docSections.push(
      new Paragraph({
        heading: "HEADING_1",
        children: [
          new TextRun({
            text: labelTranslations[type] || type,
            bold: true,
            color: "ED1D25",
            font: "Arial",
            size: 32,
          }),
        ],
      }),
      new Paragraph({ text: "", spacing: { after: 300 } }),
      buildTable(items),
      new Paragraph({ text: "", spacing: { after: 300 } }),
      new Paragraph({ text: "" })
    );
  });

  return docSections;
};

export default ModelWorldShareholding;
